<template>
  <div class="ti d-flex">
    <div class="d-flex-left">
      <erp-tree-status @node-click="nodeClick"></erp-tree-status>
    </div>
    <div class="d-flex-right">
      <div>
        <el-descriptions :column="1" border>
          <el-descriptions-item size="mini" label="房产">
            <el-input size="mini" placeholder="选择项目" v-model="home_name" clearable></el-input>
          </el-descriptions-item>
          <el-descriptions-item size="mini" label="房产类型">
            <el-checkbox-group size="mini" v-model="house_type" style="width: 100%;" @change="getData()">
              <el-checkbox label="1">住宅</el-checkbox>
              <el-checkbox label="4">商铺</el-checkbox>
              <el-checkbox label="5">写字楼</el-checkbox>
              <el-checkbox label="2">车位</el-checkbox>
              <el-checkbox label="3">储藏室</el-checkbox>
            </el-checkbox-group>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div style="width: 98%;">
        <div>
          <div class="roomCount">统计房间数量：{{roomCount}}</div>
        </div>
        <div style="display: flex;flex-direction: row">
          <div class="hosePie" id="hosePie"></div>

          <div style="margin-left: 100px;border: 1px solid #999999;margin-top: 40px;padding: 10px;border-radius: 5px;">
            <div style="font-size: 18px;font-weight: bold;">
              图标说明:
            </div>
            <div v-for="(item,index) in room_status_list" style="display: flex;flex-direction: row">
              <img :src="icons_img[item.name]" :data-img="icons_img[item.name]" style="width: 25px;height: 25px">
              &nbsp;&nbsp;
              <div style="line-height: 30px">{{item.remarks}}</div>
            </div>
          </div>
        </div>

        <!--        <el-divider />-->

        <!--        <el-table :data="room_status_list"-->
        <!--                  border-->
        <!--                  style="width: 500px">-->
        <!--          <el-table-column-->
        <!--            label="图标" width="90">-->
        <!--            <template slot-scope="scope">-->
        <!--              <img :src="icons_img[scope.row.name]" :data-img="icons_img[scope.row.name]" style="width: 25px;height: 25px">-->
        <!--            </template>-->
        <!--          </el-table-column>-->
        <!--&lt;!&ndash;          <el-table-column&ndash;&gt;-->
        <!--&lt;!&ndash;            prop="name"&ndash;&gt;-->
        <!--&lt;!&ndash;            label="名称" width="90"></el-table-column>&ndash;&gt;-->
        <!--&lt;!&ndash;          <el-table-column&ndash;&gt;-->
        <!--&lt;!&ndash;            prop="label"&ndash;&gt;-->
        <!--&lt;!&ndash;            label="形状" width="90"></el-table-column>&ndash;&gt;-->
        <!--          <el-table-column-->
        <!--            prop="remarks"-->
        <!--            label="描述" min-width="200"></el-table-column>-->

        <!--        </el-table>-->
      </div>
    </div>


  </div>
</template>

<script>
import ErpTree from "../../Common/erp-tree";
import ErpTreeStatus from "../../Common/erp-tree-status";
import SearchHouse from "../../Common/search-house";
import HouseCodeTable from "../HouseCodeTable";
import pie from "../statistics/Pie";

export default {
  name: "ProjectRoomStatusStatistics",
  components: {
    HouseCodeTable,
    SearchHouse,
    ErpTreeStatus,
    ErpTree
  },
  data(){
    return{
      activeName:'1',
      home_id:0,
      home_name:"",
      formInline:{
        name:""
      },
      activeCollapseName:'',
      roomCount:0,
      house_type:['1','4','5'],
      room_status_list:[],
      icons_img:{
        '空置': 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGUAAABbCAMAAABd0rsgAAAAYFBMVEVMaXElqHolqHolqHolqHolqHolqHolqHolqHolqHolqHolqHolqHolqHolqHolqHr////Z6t55vZmt07z2+vhDrYJZsont9O+VyKpqt5G42cXE382izbPj7+fP5NaHwqO42bzAAAAAD3RSTlMAYKCAEPDQQMAwULAg4JAgs7kmAAAACXBIWXMAAAsSAAALEgHS3X78AAACsElEQVRoge3Z2ZqjIBAG0KSz2jPdbIpbkn7/t5wvispShaDYc2PdxnBk+ZHEQ3TdTp9/478VV9kXIYSctkWOpK+P30AI+XPeDDmRqa5bMR8ashljIoRcsvTG+UrsSs8ACCGXz7RIBiGEkGNS5AIjSRkcSZjPI26kY/xIom3gNIMkyaedxU2YEGRtPsEspmaCkTXbABZ4uBbm05dFqBYxsciifM5lMQmzBIneBpDASy7Ei5W0wJiofGJZrGhfD7Q3EQwa+EIpJT5oofn0ZbFVTL2W8Qb+Rymt55qQbWAm8Hmv5N6LZvOpsig5Ukx1RsAfyyBmCLygy0qo3njzOWZxreJjpsCvVvBtQAv8egXLp57FBArMGIFPoQD5tLKolJyFVg4oDmMHXinMTRxSDFKsbcAJfCLFyKf78IWUwnyqmBsmpkwM8IQHlPppmJwyHqIM+YQevq7yyCmtrGY1B1d6BnzC24rsWsmnMePqAjmvvLeB7K7XMHaW8lALtbHvndJWgspVb9X+Q+UOKXJscnxGci2JTQEoN2QXMxRg9Lp62l3pBlK4Z5pIhZd6g8OQidzYWMpqlSKNmy6nNVXYDl+sFI3RkrmAbIfVixSrGeacjmynLeKVymgid0Ye6Gwu4pSiMia9X61Qyda4bpyeAMU/5FZxY4HQV7DymlmmVhn9boOVSvsWFDmntL7L8HmZbq6V88Z7eobuD/Mfogyd8U6INT3dnY27dohSdCPAKuy0DJ6Q38M2/nwKWsmC0vIn6rwk3tvR9OspLC/dwopUCJFxytijOIXsym8olXtIVm0+nQ+qxQpQSuFz1+3KruzKrvxfpUH/S0B3S1VNhGIeF2OK7cquBCl1xNHVrDpCWV/elwrLXru4dfchqToz90bh/B39OgzoScBri+y2sqw5ORwO/wA8AFcB2CmbAAAAAABJRU5ErkJggg==',
        '未领':'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGUAAABbCAMAAABd0rsgAAAAhFBMVEVMaXElqHolqHolqHolqHolqHolqHolqHolqHolqHolqHolqHolqHolqHolqHr29/f////+/v7Z6t74+Pit07z4+fl5vZn7+/tqt5H39/fj7+f8/Pz9/f1DrYKVyKr3+vj6+vrE381Zson6+/vP5Nb2+vi42cX5+fmizbPt9O+HwqPu9fBH8atkAAAADnRSTlMAMKDg8NBgQMAQkCBwUNKoitUAAAAJcEhZcwAACxIAAAsSAdLdfvwAAANRSURBVGiB7ZrrcpswFISJ49hO0sorAcYGfHd8Sd///ToGQW10BBISnelM92cG6Yskds9BSWCt6fTTfpClJmPG2GxgzgcrNH4ZEjJiUuPpYIz3GsIYmwwFeXuADIVpQBj7GADy8sqaGvmHjBUIY6N3v5ApBWHszStmQjI8Y7QQxl69+fNDD/EXA6M2iKcYeO+AePGn4sUhMEYQ1xggDE/LJQZIw2swvY2jMTytvv5s8SKlfhhLSL8YaDU8LfsYaHjx8B2dhfhCoVSIaLMkQJYx8GT4w/Ukp3/SbU+AbPz55MVrMXeeJHEczu8K4/iY5ByAUDnmmGfDR+DHcvpnxRmAjYIxjYGG4SMkBKNYVAZcFYxZDDQNr6fM50fgW8UYGEcxfBtlnmC7VjDd/lS9eKeElyQrzrsQz5P6oDgiZUQnhjB8BM7V9ziXnAu26pCOGKAMH90nFefron5tl5s9wMNqMQtiUFsMkMU3up3VeQ4peEnJqC1riQFNhT+QP11vcSkoOwjyAY0/DYtvpTOy0pxINU9QGEsIW8gtWwG6R9QYMK7wtYDyYPQUJQYsKrwFpREDVhXegvLkT+via0x5wPSCGFLqGOhR4e82kpQYX+0PljHQ3W2T2iCXQaZx5R/MNAgmswdZeEbgKLP/TM38OOusEWpTY8gCCGVaqlWZsZkmxewoh62sbSGgljFPlHskr2Qkn6gHfFCW2woSgiwvPijf26qGrTi9FA+UCNVKVpxqLnxQ1nvIylJAqHbZnbJOgZ1s+vQQR8o6BY/rju+mgzhSTvW5Z4Cgz8SZElWODzno3sUDZVmdyYXjl3a3XClCvl07INXvliNlKfcrBPbtv44LJSqXsuKdEBeKKNvJI27t2+VG+So3jK4o3ihlpW9pJj1S9I2xX0pXO/FvUPI8z/nglFLDUhZSrQnmTLHQf8rfo6yjtLzqU++RPFLS+nqkM/j7Uzbgu3uzt9oZhHJviqj6sHmiaVt9UGR1MUuy3pTqa9WownigdH0W+6GEXZ/FDpQUskEe9Fz29S1pNmCntACyXRzHx1zzleeFws619wftlJbRSQhxiug7RnPKZ/d4M7VSAusbP41+tFI8FZi3VkgQ/PSxmln33xOmzmr8T04QBL8BQAhDss3YymMAAAAASUVORK5CYII=',
        '空关':'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGUAAABbCAMAAABd0rsgAAAAYFBMVEVMaXElqHolqHolqHolqHolqHolqHolqHolqHolqHolqHolqHolqHolqHolqHolqHr///95vZmt07zZ6t5Zson2+vhDrYLj7+eVyKqizbPE382HwqPt9O9qt5HP5Na42cU/PEP8AAAAD3RSTlMAoGBQENAwwEDwgLAgcJDkOCaBAAAACXBIWXMAAAsSAAALEgHS3X78AAACR0lEQVRoge3Z23KCMBAGYDwXbbuRICqCvv9bdihTkg05bRK86GQvjc0n0D9ZY0Guj+NmS/8rWm1KACi/lkXWMNbqHciizApE7ZZ6ODKyFLM9ycbA7BdAdqBWmZzRIOmZfalBAGD9DiQpszEiAMdUyNpspMunHUnErBxIkny6kXhGDXx9b/mFMdbx16ORmKjg4Cw29yuTqz1PQzH5xEg1XAQu3sczKIv9VSV+q5reEJhPhNzmFzLWtYliUOBvBgMxAcsAyuLDjMgMOZ8IqU23aywOgQzOIrcijN1FcCj5xIjyUDrOOb64Sx3AqIHv5AmrccYapacVb/ZdBtTNV370T7GsNE/pdWm18cvnbIdvtZ8ZD9yBxsw3X3HDugaPiP8Kjl535nOONOIT35Shs3hceMDBaHZ441QAINY2ZcC6DOg2X6E8Z2PVNHZWRiz51O7wQhHr73xMVcyMfvMNVEz5NOzwYqYHSdEys5beZyarolkGtN12pDLLpxmJURTG3G3HKSifNiRSEYytpY9W/pYBR7cdq4z5dLX00crAbA5yae5dXf2V2HfdY2hWde08OC7Mu0yr2D9X+jOt+gDF2ICbq3tQlYpsMKk18FTqIISxmqSEXcrUmXkqrg7cVFVWspKVrGQlK1nJSlayoiihHeyNpFiPwy1F68aB/u2FSSd1vkrYLeuJCuh/cLHXdOLrrTR05gVkBZoXzeikw0B/ZfhJj3te0IW36LTZqnxBmjpZlcJ85kep8tOubL8TIAcHMtT+I7KU+Yqi+AHfBFcTMP5z2QAAAABJRU5ErkJggg==',
        '装修':'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGUAAABbCAMAAABd0rsgAAAAXVBMVEVMaXElqHolqHolqHolqHolqHolqHolqHolqHolqHolqHolqHolqHolqHolqHr///+t07x5vZnZ6t72+vhDrYLt9O+VyKrE381Zsonj7+dqt5GHwqO42cXP5NaizbPL7hm+AAAADnRSTlMAYKDgENDwwEAwgJAgULvbIdEAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAN9SURBVGiB7dnbdqMgFAbgpE2TppPZgKDiKe//mLOiApuDCkTnYtbsuzaNX1D2D6Sn5Hp839PflFj3GwB8/j4YucJY5yORM6j69TcQgI+jkB+EAHxcDkE+LATg6wjGRY5gLl8eAvC5c+cEEYDrrsw9jABcv3dErgvInv25huzGnNeMvWJgC9klBn42kR1iwO/FUL3Zn3HIe8xCL4YqPwYSkPwYWGz4BSYrBtZ7MVQZ/ZmOZDDbvRiqxBjIQxJjIKbhF5j4xontxVBF92cAoexVAv9KUtoxxrw/jWOCvUjGsi7Jpt/5fxsTAxh56g+fokTEAG74mjSKSVI2YwD3Yk2IZtKUjf50Ec2kKmsM7kXZEMQkK8sxYDe8mJkiT1mKAbfhBZ+uUxulIOtFLSbUOH4vtjPzzFNC/RlKFcV0eYrHLCy+nRpMnuLEwOIKX80PJlOxYmBlha8JaczTr6iper4wLj87TQysLr5FKaAqZwW/sDWTVZ0jEBCtMjKVidlYfI2Rq7xi4H7D5Q4LG0mKdVU31G4rRpKylGKuIqhjHKBIytHluVKqQpcKU1NVslJjgwql0NiejByLeXMtTPLvrOjB1BLgOIUh4zgFCmMYhY2hVfQ0VCxDYb00PygFOjo0rwVnq2IVq7Qyzen6GEXXNCn4wcq8erbHKnN/9vsoLDiLKJ3DrQy/KBOV1cZYLPZf+ScUydyq8LI2WC8OvGPO8TZO8erJrU+N2lIMhAx5/eKUdPeu+sQJ7dhB1fuKMJsArvY1KjDnB8idzElX0IapbNXeZQqZttGDe09h+kKEDK/71M8/VHgm8u4dpUMPhE83Xx04CTV+ISFbEfbmcjzHoiOaKe/cEq/I3rmaUqazE5pvgdUmUqn8c5dWrGTg/kAilba2h8EdBW89/fNXpCItgpQddRVAI63dJx87lgEbesZqpe1L2pNVJ0apLMNW5LgoU3sKDO4OLUaZt11EHRa0Ip9zj1AVYPrj9G2yMj7dQT/YSWkqcydfISzwXXtBdZemMMLxzfbXtOnuMe+4VqUo6CtLZ0ZZCgB1OrdNUnDJwUPM0xaWo5M5XXEChdf2hBJPc9+qfEWgT1v2oVNFN4+W6/ucrug8cWardVfHKW62zxlKu0EoqIjcJy/8s6LZJJy6rSqXz+CbxMoFQ7X1Hfxj8wQTURH/T3h8v1uOcTqd/gABJUPkP61O5wAAAABJRU5ErkJggg==',
        '入住':'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGUAAABaCAMAAACWjmiFAAAAeFBMVEVMaXElqHolqHolqHolqHolqHolqHolqHolqHolqHolqHolqHolqHolqHr///8lqHr2+vh5vZmt07xDrYJZsonE383t9O+VyKrZ6t5qt5GizbPj7+e42cWHwqPP5NbY6d6hzbKEwKD+//7k7+fq8+3b6+G+3MnZ6t88mnf7AAAADnRSTlMA8MBAEKBggNAwkHDgUMLWMDMAAAAJcEhZcwAACxIAAAsSAdLdfvwAAANoSURBVGiB3ZnteuIgEIWt1ard3ZCQD5MYtft9/3e4jxpgAjOEIdgfe342gbcMc2Ygrrh6fV/vXtmjmNqKm96fytjsxUPbz4AIsd88C3IwkOdhDi8AIsT+8AkQIV6egHkTjtJjEIgQ4i0tZIdCEmO2BESI3WdA0vlzs/dAUmFmIGn8eZiDpMA4XkQxC40TBFnqT9yLiTHBkCX+pAyfFOPzIqaoMsCFxPhz1ospMFEQrj9pwxf90LZtK/tuMYbyYlHnmVYzVBgm2DgEpGgN4qEa4YT6E/diOdiMLMvyPhZDQE4I5Lac0n03wJ+44bsch2TZKQaDe7FsKEiWnZD3Z8oAYfhpuE5T5oAM8PmT8qIE+dvf86qTgHRmYShIZXLqCNB6qxpka0h/koav8Z02GSGxUTiGbL4VDgGYBh2HlQG6w6tdyR2nF76dwfzpab4qwRCfq1jW+Egb44GUnrBU3pDZ/vR1eBUWzBZ6nViW2Rhv81XbUrAf3rULguiJsG6iF0pTRn/ONV9FQR8GUO6Y2Q6/mHLz57cdlIeCTtRTDyez2t9tkInOtF2MYZxNw4sYTenGiVqMklPh5FL0TEjIjuR/wKbU5FRlTkaTTVEb4xb4i3rieolNEbotgh4GF4kVSz5FRT/LBlCvSnMIRMoCnyLMfM1x5FSmIaN1NIJSwdPYz+v1+vcX+AN2IouhgJi5ytHTfwzFg8EhcZTqNwH58QdvYBGUUhKMzDqjLaEUnlPyTW2KTPYtZFyOe1LiUupZCFbIeJRyes1rall8//gozvIyvdHYRYZHgZB8mGTtufZgWBQwUS6dnK0gZ5pqHEpvJrmgvqjAWiddjkHpzEJQU4hJBubw/2BQ9EWPKCN3meJziaLIEAjEgJgFU3RX90MABhz9gyl6KeSeKNXum6EUvZQLNbl5VRU6c/cPpag4uBc9V/rq13EpKsHQC7AtZRt9BAik6Jsxec2CUovR+x9IUQEjLqa2GitkgRSVN/gl25GqRaoFBFLUtoRBdDFSSw+kjKPQ+wSmfPp+GEVtflCGCZBlLEphxXlW9RKK91oKJf8jSh9DGXOG/IzjqIrJsccntrnOAnUvFo0qrYEUUfWyD6pheoCURz3AS/nKmdajvZfC+ymM1szX8bhfd2zN/qj0Zb2YsZ6uZLVa/QMNEUxsUyLJAQAAAABJRU5ErkJggg==',
        '出租':'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGUAAABbCAMAAABd0rsgAAAAWlBMVEVMaXElqHolqHolqHolqHolqHolqHolqHolqHolqHolqHolqHolqHolqHr////Z6t55vZmt07zj7+fE381Zson2+vhDrYKVyKpqt5Ht9O/P5NaizbOHwqO42cUc/gKDAAAADXRSTlMAENBwMGCgQMDwIOCwbE65AAAAAAlwSFlzAAALEgAACxIB0t1+/AAAApxJREFUaIHtmsmWwiAQRZ3HLgwZnfr/f7NPElCGgkAoXPTx7bRNXY3cF9ReRGez38QfFJn9GQDOmTlbGHLc5oSsQSYjZgfvrD8BAdhlYSwPGiQPZrkCM4clNeRkQwBWxJjNEYEArE4fgAAcCf3cuiCUmK2TQVgDax+EqgZ2ExCSGpiGpPtpCZ8DgwiPJ6UGUOHxzK8Bp4tY5tZAFGSunx7h6TBe4R2YaD+nhMcTiQlxEUtUDcyFxPgZKHwaJlh4PGE1ECE8npAacLp4fdxZEYaZrAEcUvBLwxhjD4CLO1f58Ck/beGLR1UymV8A5s77lfoxmvB1we+lPvISSPHWgCJ8V2JzmlCKpwZUFwt8UBtMcdWAJjxGuVXPCArqpyF8bUwof7t6+IO4qS20EqUgGEt480zp9+sDC5xi1YAt/ODH7c7HASY9jGLUAOIi513xnjqTotWA7wqfRlH89F7hEykvjP8Kn0oRNTBxhU+mDDWwPagho2hTze58PaqTxo0D5K0ulOJqMZ3C8RLhoe6TUNB8Kfkpnfa+WmuMiCJhYoDpC9EaE7k5KES+aIczBnVGyl1SKtZlo2gX/2cuSqVSmmseirGPGTHklIoZmH4JUFOulnZlS0+5WJT3bpyMou1hZa1V1O7fVIp8j5rWfoGvzKCIZy9OmxSUuC3rRhwpKW05nDBaitxVvPcwdaOsMRrKQxxYKzulJ+u1JKTI81Vp+7Ghl8fbJGtMnK+mnb3rC6GIdcvn7y1DKO0gyw3yUsYOS/mUFETpF1mlTM1EgXvTfoDSFurUXBR96n+jFLyPKAWuplLuLBIpjg26Ef6lfCmzKVGJpIxaxELOXspP9JPG4/9N4RT7MxWe48RX/Zv+/11SY329g3D2qTEYi8XiD8+wKmTBFS82AAAAAElFTkSuQmCC',
        '停用':'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGUAAABaCAMAAACWjmiFAAAAaVBMVEVMaXElqHolqHolqHolqHolqHolqHolqHolqHolqHolqHolqHolqHolqHolqHolqHolqHr///+t07xDrYLj7+f3+vhZsolqt5HZ6t7E382izbN5vZnt9O+42cWHwqPP5NaVyKru9fDm8OjwC7f4AAAAEHRSTlMAYFCwMKDwgBDQwOBwkCBA1HLvXAAAAAlwSFlzAAALEgAACxIB0t1+/AAAAxBJREFUaIHtmdd62zAMhZVWXknaINrWtPv+D9lP0eIASIKictOeu9imfgHgAUciri5vAG8/2MN4OsGXTkcyrjeAwzEbBODn9SBILEAAbsdg4rMIOQijQgDOcXDIi8o4AoNBAM5hjXNBIQDwEhByoiAhMQZIMH9ebyZIIIwNEqQNxFZIAH/qXjwA4wbZ6U/ci4Ex7pAdbYA0PC4/fxq9iMkHw4Z4+NPuxQAYPwizDbgYHhfDn65exOSM2QNx9qfJi02ffKkvd2JISJlkn4KquqAw9jZAGD6t209N2YPg2PxJeDHJdcaoluCYMTikQeJY48ErZPAn4cWOZoxKeBgckso1v49TbJA+G1JsHNEGcMMX2wPzrtk+7+9bqTIUg/oT92L6JAud1jkbQ0CWSHIs+2myJhIbrPuT8OJgnklQLqF2LhgCUhvrC2KwPY4RjUMYvpifcKcYAiYnXmTDUItvZUq6isFzBvBugTTT8CeZrknFPNWo5nkyGH4LpaG+X1Rb8noyQUp7UeTXIWN+VSa0OA3u5kQImlNbCx9dqDamUnLXUJZgMg/KnDDD0rup18J2pUzdo3WBLHELznSlDEYXKBrUlcaV0hoah6Zata8rRUl1WieatrWgUcvPoyx/Fej2Yl1XCvnXzpRSHnfHIIJFPCmNPK7CKcNOihLLgFP2xqKMK9G6/NlbF3WOFfoUS+q1P075bfmU7/GLh/eFH/P6WIY+VNNUNWHH5kpplMKY5N+Tv2d9me1O7YBEFYp5OBT2ui8m15nivIfpkddxp8z1b332Y+6UJZhBfa6kZW8pZ5ZBmSvjs09mUCCxYqg9P4eyLisZYc4yI96DRdnOYjUgWs9iWiNiUYR1Rb9AeKzXAPq5kkcRl6+2EzaaTWc8IzMp8nk/r7px+eqkbUCFGIpLgZTYvyxC7y7YFID+STNavAF5UCCl7pTwqedJGTnIvVL7IFucH2WcbZ10x5N1pqONN2WMqJn35A/bcrCH4q7/lH+ZYrzq/QhF+W2iRK9hIL+MkOgaBGP/n1J82at3+bYyiqK/2pBpk3YsT3sAAAAASUVORK5CYII=',
        '未设置':'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAA0lJREFUWEfl2Fuo5mMUx/HPunExLuRUMhJFwgVSk5mkIYdxTNGUIqcwKLkwTTOM86EckhLGuSGZJkTTjENCDpMbIk0aExe4YySEq0fP/v/3bu///r/v//C+u3nLunz3Wr/13et5nvWs5x8m3GLC+fx/ABOPYjkW4y3cH3w/6gqNpYKJ+7CuAvMJzgt+HwVyZMDEBXhzAMRrwcV7GvAjnDIE4rLg5b6QI1UwcRMea0j+JZYF//SB7A2YOASf4tAWidcFD7Twm+cyCmA+tTe3TPoLlga7WvrPuPUCTJyMjzsmezK4oWNMv0adeAMXdk2G04IPusR1rmDiUrxUkyTvx1cVzXkJ7qjx2RKcv2CAiUXlwTi+kmRncNTs3xIv4IoamMuDjW0hO1UwsR5314g/EtxSAczXXt1yflUemL/bQLYGTByDz7BPjfCpwYfV31MBmEGrdlsU12OjdQF8DlcNUKxdtsTPOLgmZndZxZ1NhK0AE+diyxCx9cG9lSXeG38OidkQrBoX4Pu5RQwReya4tgKYD1K+5obZ6UHWHmiNFUzciMcbEr0TrKgArsSmhritUaxOP8DEQeXBOLwh0a7gyArgrSrLPkDjyuDFQfpDK5h4SKV9DAFdFMy0jsTTuKZpj+Hrctr5q853IGBiadmUG7dBKXxcFMmmLPE2zmoBmF1uD+7pCrhZt2n4ouD1WYA7cHRLwN/KKn5b9a+tTuISvNJSfNptTfBgWb198SNyq2lr8zpBDpwHmNirPBgntlUu/Z6Ncs8lTsAXHeOz+5nBe7Pj6gDX5idjD/HqVVd3xTXJbgvOGQiYiokkj037Nykt4N+vDp6f1p9TwQ6toY7vc8UezEubZ8G6UavN//VNeWD+mLMHU9EScmvoY9uDZbMDUwG7uo8Y7gzuqgK+izN6Cs57tSUOww899fLXiPxU3TG1xInr8FRPsRy2Msh9c44lvsMRPXWnukIkDiwPxpy7tKPo5iAPBzOWOBtbO+pU3VdkwOvxxIhCOTw/zB8Odqdi9NowBs1NGXCbyqg0ovBPiq8O47B/M+Cv2G8caguhkQHznZvv3om0DJi/7+UH0QETSLhxus3kwSAflpNw7B4GzXt4u6IH5oY92fYfSrSzqReo6oAAAAAASUVORK5CYII=',
      }
    }
  },
  mounted() {
    this.getData()
    this.getRoomStatusList();
  },
  methods:{
    nodeClick(data){
      this.home_name=data.tree.map(ret => {
        return ret.name
      }).join('->');
      if(data.tree[data.tree.length-1].type==='room'){
        this.home_id=data.tree[data.tree.length-1].id;
      }else {
        this.home_id=""
      }


    },
    getData(){
      const that = this;
      ERP.showLoading();
      ERP.getRequest({url:"admin/HouseCode/getHouseStatistics",data:{
          name:that.home_name,
          house_type:that.house_type.join(','),
          id:that.home_id,
        }},ret=>{
        ERP.hideLoading();
        if(ret.code){
          that.roomCount=ret.data.total
          ret.data.list.map(res=>{
            res.icon="image://"+this.icons_img[res.name];
            return res;
          })
          pie.hosePie("hosePie",ret.data.list)
        }else{
          this.$msgbox.alert(ret.msg||"查询失败")
        }
      },ee=>{
        ERP.hideLoading();
      })
    },
    onSubmit(){
      console.log(this.formInline)
      const that = this;//getHouseStatistics
      that.$refs.HouseCodeTable.getData(that.home_id||0,1)
    },
    outClik(status){
      status&&this.$refs.CustomerRentTable.getData(this.home_id)
      status&&this.$refs.CustomerRentLog.getData(this.home_id)
    },
    onTable(e){
      this.home_id=e.data.house_id;
      this.home_name=e.data.address;
      console.log(e);
    },
    onForm(e){
      if(e){
        this.$refs.CustomerRentTable.getData(this.home_id)
      }
      this.openWinStatus=false;
    },
    edtiClik(e){
      console.log(e)
    },
    billPrintClick(furnish_id){
      const that = this;
      if(!furnish_id){
        that.$alert("没选中装修编号")
      }
      furnish_id&&that.$refs.PrintFurnish.getData({
        home_id:that.home_id,
        furnish_id,
        success(ret){
          that.printJS()
        },
        error:e=>{
          that.$alert("打印异常")
        }
      })

    },
    initRoomStatus(){
      ERP.showLoading()
      ERP.getRequest({url:"admin/CustomerManagement/initRoomStatus",data:{}},ret=>{
        if(ret.code){
          this.$msgbox.alert(ret.msg||"初始化成功")
        }else{
          this.$msgbox.alert(ret.msg||"查询失败")
        }
        ERP.hideLoading()
      },err=>{
        ERP.hideLoading()
        this.$msgbox.alert("请求超时，重新试试！")
      })
    },
    initUser(){
      ERP.showLoading()
      ERP.getRequest({url:"admin/HouseCode/initUser",data:{}},ret=>{
        if(ret.code){
          this.$msgbox.alert(ret.msg||"初始化成功")
        }else{
          this.$msgbox.alert(ret.msg||"查询失败")
        }
        ERP.hideLoading()
      },err=>{
        ERP.hideLoading()
        this.$msgbox.alert("请求超时，重新试试！")
      })
    },
    getRoomStatusList(){
      const that = this;
      ERP.getRequest({url:"admin/HouseCode/getRoomStatusList",data:{}},ret=>{
        if(ret.code){
          that.room_status_list=ret.data

        }
      })
    },
  },
  watch:{
    home_name(n){
      this.getData(this.home_id)
    }
  }
}
</script>

<style lang="scss" scoped>
.el-button--primary,.el-button--success,.el-button--danger,.el-button--warning {
  color: #FFF;
}
.ti{
  //padding: 20px;
  //width: 98%;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhanwu{
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
}
.hosePie{
  width: 500px;
  height: 400px;
}
.roomCount{
  font-size: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/HouseCode/components/ProjectRoomStatusStatistics.vue